import React, { useContext, useEffect, useState } from "react";
import { People, Mail } from "@reverb-ui/icons-react";
import { Avatar, Box, Center, Flex, HStack, IconButton, Select, Spinner, Stack, Text, } from "@reverb-ui/react";
import { useTranslation } from "react-i18next";
import { ClientEmployeeContext } from "@/shared/presentation/context-api/providers/client-employee";
export var RockContentTeam = function () {
    var t = useTranslation("my-account").t;
    var _a = useState(), selectedClient = _a[0], setSelectedClient = _a[1];
    var _b = useState(false), loadingScreen = _b[0], setLoadingScreen = _b[1];
    var _c = useContext(ClientEmployeeContext), employeeClients = _c.employeeClients, defaultValueEmployeeClient = _c.defaultValueEmployeeClient, getAllContractsByClientRockId = _c.getAllContractsByClientRockId, loading = _c.loading, responsiblesClientContracts = _c.responsiblesClientContracts;
    var listClientSelect = employeeClients().map(function (client) {
        var _a;
        return {
            label: client.name,
            value: client.rockId,
            locationId: (_a = client.location) === null || _a === void 0 ? void 0 : _a.id,
        };
    });
    var handleClientChange = function (selected) {
        if (selected === null || selected === void 0 ? void 0 : selected.value) {
            getAllContractsByClientRockId(selected.value, false);
            setLoadingScreen(false);
        }
        setSelectedClient(selected);
    };
    var defaultClient = defaultValueEmployeeClient();
    useEffect(function () {
        if (!selectedClient && defaultClient) {
            setLoadingScreen(true);
            handleClientChange(defaultClient);
        }
    }, [defaultClient]);
    var redirectEmail = function (email) {
        var href = "mailto:" + email;
        window.open(href);
    };
    return (React.createElement(Box, { bg: "white", p: "6", px: "6", boxShadow: "md", borderRadius: "8" },
        React.createElement(HStack, { spacing: 4, pt: 2, pl: 2 },
            React.createElement(People, { color: "gray.400" }),
            React.createElement(Text, { color: "black", fontWeight: "600", fontSize: "xl" }, t("rock-content-team"))),
        loadingScreen && (React.createElement(Center, { w: "full", p: 12 },
            React.createElement(Spinner, { color: "blue.500" }))),
        !loadingScreen && (listClientSelect === null || listClientSelect === void 0 ? void 0 : listClientSelect.length) > 1 && (React.createElement(Flex, { direction: "column", alignItems: "center", pt: "8", w: "full" },
            React.createElement(Flex, { direction: "row", alignItems: "center", p: "8px 16px", w: "xs", h: "40px", mb: "24px", gap: "8px" },
                React.createElement(Stack, { flex: "1" },
                    React.createElement(Select, { onChange: handleClientChange, value: selectedClient, options: listClientSelect, defaultValue: defaultClient, isDisabled: !!loading }))))),
        !loadingScreen && loading && (React.createElement(Center, { w: "full", p: 12 },
            React.createElement(Spinner, { color: "blue.500" }))),
        !loading &&
            responsiblesClientContracts.map(function (responsible, index) { return (React.createElement(Flex, { key: index, direction: "column", w: "full" },
                React.createElement(Flex, { direction: "row", pt: 4, pb: 2, alignItems: "start", justifyContent: "space-between", gridGap: "3" },
                    React.createElement(Flex, { justifyContent: "flex-start" },
                        React.createElement(Avatar, { size: "sm", src: responsible.avatar }),
                        React.createElement(Box, { pl: 8 },
                            React.createElement(Text, { fontSize: "md", fontWeight: "600" }, responsible.name),
                            React.createElement(Text, { fontSize: "xs", color: "gray.500" }, responsible.role))),
                    React.createElement(IconButton, { variant: "ghost", "aria-label": "Email", onClick: function () { return redirectEmail(responsible.email); }, icon: React.createElement(Flex, { w: "full", justifyContent: "center" },
                            React.createElement(Mail, { color: "black", size: "md" })) })))); }),
        !loading &&
            !responsiblesClientContracts.length &&
            (!!selectedClient || !(listClientSelect === null || listClientSelect === void 0 ? void 0 : listClientSelect.length)) && (React.createElement(Flex, { direction: "column", alignItems: "center" },
            React.createElement(Stack, { flex: "1" },
                React.createElement(Text, { fontSize: "sm", color: "gray.400", p: "8" }, t("no-rock-content-team")))))));
};
